import styled from 'styled-components'

import Background from '../../atoms/Background'

const PageBackground = styled(Background).attrs({
  type: 'gray50',
})`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 64px;
  display: flex;
  flex-direction: column;
`

export default PageBackground
